import { render } from "./MessageCenter.vue?vue&type=template&id=c80ebb46&ts=true&class=bg-white"
import script from "./MessageCenter.ts?vue&type=script&lang=ts&external"
export * from "./MessageCenter.ts?vue&type=script&lang=ts&external"

import "./MessageCenter.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__